import React from "react"
import styled, { css } from "styled-components"

import { when, maxWidth, minWidth } from "utils"

import CloudinaryImage from "components/cloudinary-image"

export const Logo = styled(CloudinaryImage)`
  width: calc(3.5rem / ${({ aspectRatio }) => aspectRatio});
  height: 3.5rem;
  margin: 0 auto;

  ${when("left")`
    margin: 0;
  `}

  margin-bottom: 2rem;

  img {
    object-fit: contain;
  }
`

export const DesktopWrapper = styled.div`
  ${maxWidth.mobile`
    display: none;
  `}
`

export const MobileWrapper = styled.div`
  display: none;

  ${maxWidth.mobile`
    display: block;
  `}
`

export const PreheadingDesktop = styled.h3`
  strong,
  em {
    font-style: inherit;
    color: ${({ theme }) => theme.component?.highlight};
  }

  span.sponsored-by {
    padding: 0.4rem;
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.35rem;
    letter-spacing: 0.1rem;
    background-color: ${({ theme }) => (theme.component?.isDarkBackground ? "#fff" : "#222")};
    color: ${({ theme }) =>
      theme.component?.highlight || theme.component?.text || theme.colors.text.primary};
  }
`

export const PreheadingMobileWrapper = styled.div`
  display: flex;
`

export const PreheadingLine = styled.span`
  width: 100%;
  height: 0.1rem;
  margin-top: 0.7rem;
  display: inline-block;
  vertical-align: middle;
  background-color: #d0d0d0;
`

export const PreheadingMobile = styled(PreheadingDesktop)`
  margin: 0 1.5rem 3rem;
  color: #222 !important;
`

export const Preheading = ({ useLineOnMobile, ...props }) =>
  !useLineOnMobile ? (
    <PreheadingDesktop {...props} />
  ) : (
    <>
      <DesktopWrapper>
        <PreheadingDesktop {...props} />
      </DesktopWrapper>
      <MobileWrapper>
        <PreheadingMobileWrapper>
          <PreheadingLine />
          <PreheadingMobile {...props} />
          <PreheadingLine />
        </PreheadingMobileWrapper>
      </MobileWrapper>
    </>
  )

export const Heading = styled.h2`
  strong,
  em {
    color: ${({ theme }) =>
      theme.component?.heading || theme.component?.text || theme.colors.text.primary};
  }

  /* Rich text styling */
  p {
    margin: 0;
    display: contents;
  }

  /* "feel the power" - bold sans-serif */
  b,
  strong {
    font-weight: 700;
  }

  /* "fuel your strength" - italic serif */
  i,
  em {
    font-style: italic;
    font-family: Abril, "Helvetica Neue", Helvetica, Arial, sans-serif;
  }

  ${when("isSerif")`
    font-family: Abril, "Helvetica Neue", Helvetica, Arial, sans-serif;
  `}
`

export const Subheading = styled.h4`
  strong,
  em {
    font-style: inherit;
    color: ${({ theme }) => theme.component?.highlight};
  }
`

export const Body = styled.div`
  em {
    font-size: 1.8rem;
    font-weight: ${({ isArticle }) => (isArticle ? 400 : 700)};
    font-style: ${({ isArticle }) => (isArticle ? "italic" : "inherit")};
    color: ${({ theme, isArticle }) => (isArticle ? "inherit" : theme.component?.highlight)};
  }

  strong {
    font-size: inherit;
    font-weight: 700;
    font-style: inherit;
    color: ${({ theme, isArticle }) => (isArticle ? "inherit" : theme.component?.highlight)};
  }

  a {
    font-size: inherit;
    font-weight: ${({ isArticle }) => (isArticle ? 400 : 500)};
    line-height: 1.56;
    text-decoration: underline;
    color: ${({ theme, isArticle }) =>
      isArticle ? theme.article.color : theme.component?.highlight};
    word-wrap: break-word;
  }

  h2 {
    color: ${({ theme }) => theme.component?.largeHeading};
  }
`

export const BodyImage = styled.img`
  margin-bottom: 2rem;
`

export const LayoutPreheading = styled(Preheading)`
  font-size: 0.8rem;
  font-weight: 500;
  letter-spacing: 0.1rem;
  text-transform: uppercase;
  color: #2260b2;
  margin-bottom: 1rem;

  ${minWidth.tablet`
    font-size: 1.2rem;
  `}

  ${minWidth.desktop`
    font-size: 1.4rem;
  `}
`

export const LayoutHeading = styled(Heading)`
  font-size: 1.8rem;
  font-weight: 400;
  line-height: 1.2;
  color: #222222;

  ${minWidth.tablet`
    font-size: 2.4rem;
  `}

  ${minWidth.desktop`
    font-size: 3rem;
  `}
`

export const LayoutButton = styled.div`
  margin-top: 2rem;
  display: none;
  justify-content: flex-start;

  ${minWidth.tablet`
    display: flex;
  `}
`
